import React, {Fragment} from 'react';
import _ from "lodash";
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {
    Button, Grid,
    List, ListItem,
    CircularProgress
} from '@material-ui/core';
import {
    uploadFile,
    deleteFile,
    checkFile,
    resetFile,
    resetUploads,
    setDefaultFiles
} from '../../../vendors/actions/documents';
import {downloadFile} from "../../../vendors/utils/common";

interface OwnProps {
    uploadFile?: any,
    deleteFile?: any,
    checkFile?: any,
    resetFile?: any,
    resetUploads?: any,
    setDefaultFiles?: any,
    defaults?: any,
    inline?: any
}

interface ConnectStateProps {
    Documents: any
}

interface ConnectDispatchProps {
    uploadFile?: (data: any) => void,
    deleteFile?: (data: any) => void,
    checkFile?: (data: any) => void,
    resetFile?: (data: any) => void,
    setDefaultFiles?: (data: any) => void,
    resetUploads?: () => void
}

interface MainState {
    uploads: any,
    validItems: any
    invalidItems: any
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;


class FileUpload extends React.Component<HeaderProps, MainState> {
    constructor(props: any) {
        super(props);
        this.state = {
            uploads: [],
            validItems: [],
            invalidItems: []
        };

        const {defaults = []} = props;
        if (defaults.length) {
            props.setDefaultFiles(defaults);
        }
    }

    private fileInput: any = React.createRef<HTMLDivElement>();

    static getDerivedStateFromProps(props: any, state: any) {
        const {uploads, invalidItems, validItems, fileLoading} = props.Documents;
        const returnObj = {};

        if (!_.isEqual(state.uploads, uploads) && uploads) {
            Object.assign(returnObj, {uploads});
        }
        if (!_.isEqual(state.validItems, validItems) && validItems) {

            const fd = new FormData();
            for (let item of validItems) {
//ios Take photo workround
                if (item.name === 'image.jpg' || item.name === 'image.png') {
                    const blob = item.slice(0, item.size, 'image/png');
                    item = new File([blob], `${Date.now()}_${item.name}`, {type: item.type});
                }
                fd.append('file', item);
            }

            Object.assign(returnObj, {validItems: []});
            props.uploadFile(fd);

        }
        if (!_.isEqual(state.invalidItems, invalidItems) && invalidItems) {
            Object.assign(returnObj, {invalidItems})
        }
        if (state.progressError && !fileLoading) {
            Object.assign(returnObj, {progressError: false});
        }


        return _.isEmpty(returnObj) ? null : returnObj;

    }

    componentDidUpdate(prevProps: any, prevState: any) {

        const {validItems, invalidItems, action} = this.props.Documents;

        if (validItems.length && action !== 'FILES_CHECK') {
            this.props.resetFile({
                field: 'validItems'
            })
        }
        if (invalidItems.length && action !== 'FILES_CHECK') {
            this.props.resetFile({
                field: 'invalidItems'
            })
        }
    }

    componentWillUnmount() {
        this.props.resetUploads()
    }

    handleChange = (e: any) => {

        this.props.checkFile({uploads: e.target.files});

        if (this.fileInput) {
            this.fileInput.value = ''
        }
    };

    deleteFile = (e: any, file: any) => {
        const {defaults = []} = this.props;

        if (defaults.find((el: any) => el.name === file.name)) {
            return this.props.resetFile({
                field: {
                    val: 'uploads',
                    legend: file.name
                }
            });
        }

        this.props.resetFile({
            field: {
                val: 'uploads',
                legend: file.name
            }
        });
        this.props.deleteFile({fileName: file.name, ...file})
    };

    render() {

        const {uploads = [], invalidItems = []} = this.state;
        const {Documents, inline = true} = this.props;
        const {fileLoading} = Documents;

        return <Fragment>
            {!!invalidItems.length && <Grid>
                <List className="text-left upload-list error">
                    {invalidItems.map((file: any, index: any) => {
                        return <ListItem className={`upload-list-item`} key={index}>
                            <div className="d-block f-name">
                                {file.name}
                            </div>
                            <div className="d-block">
                                {file.error}
                            </div>
                        </ListItem>
                    })}
                </List>
            </Grid>}
            <Grid container spacing={inline ? 2 : 0} className="align-center file-upload-box">
                <Grid
                    item
                    xs={12}
                    md={inline ? 6 : 12}
                    lg={inline ? 3 : 12}
                    className="align-center">
                    <label htmlFor="file-upload" className={'d-flex align-items-center file-upload-label'}>
                        <input
                            onChange={(e) => this.handleChange(e)}
                            className={'d-none'}
                            accept="image/jpeg, image/jpg, image/png, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/plain"
                            id="file-upload"
                            multiple
                            ref={ref => this.fileInput = ref}
                            name="file"
                            type="file"
                        />
                        <span className={'upload-icon'}/>Attach Files
                    </label>
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={inline ? 6 : 12}
                    lg={inline ? 9 : 12}
                    className="d-flex align-center">
                    <List className="text-left upload-list w-100">
                        {uploads.map((file: any, index: any) => {
                            return <ListItem className='d-flex upload-list-item'
                                             key={index}>
                                <div className="align-box-row d-block text-truncate">
                                    <a
                                        onClick={(e) => downloadFile(e, file.url, file.name)}
                                        download={file.name}
                                        href={file.url}>{file.name}</a>
                                </div>
                                <Button
                                    onClick={(e) => this.deleteFile(e, file)}
                                    className="delete-item float-right">
                                    <div/>
                                </Button>
                            </ListItem>
                        })}
                    </List>
                </Grid>
                {fileLoading && <div className={'m-auto'}>
                    <CircularProgress/>
                </div>}
            </Grid>
        </Fragment>
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Documents} = state;
    return {
        Documents
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        uploadFile: (data: any) => dispatch(uploadFile(data)),
        deleteFile: (data: any) => dispatch(deleteFile(data)),
        checkFile: (data: any) => dispatch(checkFile(data)),
        resetFile: (data: any) => dispatch(resetFile(data)),
        resetUploads: () => dispatch(resetUploads()),
        setDefaultFiles: (data: any) => dispatch(setDefaultFiles(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(FileUpload);
